import React from 'react';
import { Input } from 'components/UIForm';
import { validateComment } from 'utils/validation';
import { addCardComment } from 'redux_store/modules/tenderCard';
import commentBlue from 'theme/icon/comment-blue.png';
import { Field, reduxForm, propTypes, reset } from 'redux-form';

import styles from './styles.scss';

@reduxForm({
  form: 'addCardComment',
  onSubmit: addCardComment,
})
export default class NewComment extends React.PureComponent {
  static propTypes = {
    ...propTypes,
  };

  constructor(props) {
    super(props);
    this.state = {
      comment: null,
    };
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <form
        onSubmit={handleSubmit(() => {
          handleSubmit();
          this.props.dispatch(reset('addCardComment'));
        })}
        className={styles.newComment}
      >
        <Field
          component={Input}
          name="comment"
          placeholder="Напишите комментарий"
          maxLength={200}
          value={this.state.comment}
          validate={validateComment}
          onChange={(e, value) => this.setState({ comment: value })}
          suffix={<img alt="" className={styles.image} src={commentBlue} />}
        />
      </form>
    );
  }
}
